import React from 'react'
import Header from './Header'
import BottomNavigation from 'components/BottomNavigation'
import MailIcon from '@material-ui/icons/Mail'
import CallIcon from '@material-ui/icons/Call'
import { telephone, email } from '../contactNumber'
import 'style/about-us.css'

const AboutUs = () =>
    <>
        <Header title="طبینجا" desc="درباره ما" showBackButton />
        <div className="root-page">
            <p>
                طبینجا یکی از استارت‌آپ‌های در حال توسعه شرکت گروه رادوین تجارت خاورمیانه است. تیم طبینجا بر اساس ایده‌ها و ارزش‌هایی قوی پایه‌گذاری شده تا با تکیه بر پشتوانه و پیشینه قوی این گروه شاهد ارتقای خدمات آنلاین در حوزه پزشکی و سلامت ایران باشیم. مایه فخر و مباهات ماست که در فضایی رو به رشد که نوآوری و عزم راسخ پایه و اساس آن است، در جهت بهبود صنعت تندرستی و دنیای اطرافمان فعالیت می‌کنیم. با اتکا به منش مثبت و روحیه قوی تیمی می‌خواهیم که با موفقیت روزافزون به خدمت رسانی به مشتری‌هایمان بپردازیم.
            </p>
            <div className="contact-box">
                <p>در صورتی که در این زمینه پرسشی یا پیشنهاد و انتقادی دارید، همکاران ما آماده پاسخگویی هستند.</p>
                <div className="contact-us">
                    <div className="contact-us__email">
                        <div className="icon"><MailIcon /></div>
                        <a href={`mailto: ${email}`}>info@tebinja.com</a>
                    </div>
                    <div className="contact-us__call">
                        <div className="icon"><CallIcon /></div>
                        <a href={`tel: ${telephone}`}>۰۲۱-۷۱۱۴۸۱۰۰</a>
                    </div>
                </div>
            </div>
        </div>
        <BottomNavigation selected={null} />
    </>

export default AboutUs